module.exports = __webpack_public_path__ + "static/media/goodnest3.e65fb9fd.jpg";